import API from '../../../modules/common/services/api.config.json';
import { Observable, Subject } from 'rxjs';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { User } from '../model/User';
import { Injectable } from '@angular/core';

@Injectable()
export class UserManagementService {

  public clickedAddNewUser$: Subject<void> = new Subject();
  public updateUserList$: Subject<void> = new Subject();

  constructor(private apiService: ApiService) { }

  getUsersList(): Observable<RestResponse> {
    let url = `${API.UserManagement.getUserList}`;
    return this.apiService.get(url);
  }

  getUserById(userId: number): Observable<RestResponse> {
    let url = `${API.UserManagement.getUserById}`;
    url = url.replace('{id}', userId.toString());
    return this.apiService.get(url);
  }

  addUser(user: User): Observable<RestResponse> {
    let url = `${API.UserManagement.addUser}`;
    return this.apiService.post(url, user);
  }

  updateUser(user: User): Observable<RestResponse> {
    let url = `${API.UserManagement.updateUser}`;
    return this.apiService.put(url, user);
  }

  deleteUser(userId: any): Observable<RestResponse> {
    let url = `${API.UserManagement.deleteUser}`;
    url = url.replace('{id}', userId);
    return this.apiService.delete(url);
  }

  getMainRolePrincipals(): Observable<RestResponse> {
    let url = `${API.UserManagement.getMainRolePrincipals}`;
    return this.apiService.get(url);
  }

  getOtherRolePrincipals(): Observable<RestResponse> {
    let url = `${API.UserManagement.getOtherRolePrincipals}`;
    return this.apiService.get(url);
  }

  getUserRoles(abriviation: any): Observable<RestResponse> {
    let url = `${API.UserManagement.getUserRoles}`;
    url = url.replace('{abriviation}', abriviation);
    return this.apiService.get(url);
  }

  addUserRole(userRole: any): Observable<RestResponse> {
    let url = `${API.UserManagement.addUserRole}`;
    return this.apiService.post(url, userRole);
  }

  deleteUserRole(userRoleId: any, abriviation: string): Observable<RestResponse> {
    let url = `${API.UserManagement.deleteUserRole}`;
    url = url.replace('{userRoleId}', userRoleId);
    url = url.replace('{abriviation}', abriviation);
    return this.apiService.delete(url);
  }


  getRoles(): Observable<RestResponse> {
    let url = `${API.UserManagement.getRoles}`;
    return this.apiService.get(url);
  }

  addRole(role: any): Observable<RestResponse> {
    let url = `${API.UserManagement.addRole}`;
    return this.apiService.post(url, role);
  }

  updateRole(role: any): Observable<RestResponse> {
    let url = `${API.UserManagement.updateRole}`;
    return this.apiService.put(url, role);
  }

  deleteRole(id: any): Observable<RestResponse> {
    let url = `${API.UserManagement.deleteRole}`;
    url = url.replace('{id}', id);
    return this.apiService.delete(url);
  }

  getUserCompanies(abriviation: any): Observable<RestResponse> {
    let url = `${API.UserManagement.getUserCompanies}`;
    url = url.replace('{abriviation}', abriviation);
    return this.apiService.get(url);
  }

  addUserCompany(userCompany: any): Observable<RestResponse> {
    let url = `${API.UserManagement.addUserCompany}`;
    return this.apiService.post(url, userCompany);
  }

  deleteUserCompany(companyId: any, abriviation: any): Observable<RestResponse> {
    let url = `${API.UserManagement.deleteUserCompany}`;
    url = url.replace('{companyId}', companyId);
    url = url.replace('{abriviation}', abriviation);
    return this.apiService.delete(url);
  }

  getControlDeAccesosFile(startDate: any, endDate): Observable<RestResponse> {
    let url = `${API.UserManagement.getControlDeAccesosFile}`;
    url += '?startDate=' + startDate + '&endDate=' + endDate + '';;
    return this.apiService.get(url);
  }

   getListadoDeUsuariosFileActivos(): Observable<RestResponse> {
    let url = `${API.UserManagement.getListadoDeUsuariosActivosFile}`;
    return this.apiService.get(url);
  }

  getListadoDeUsuariosFileInactivos(): Observable<RestResponse> {
    let url = `${API.UserManagement.getListadoDeUsuariosInactivosFile}`;
    return this.apiService.get(url);
  }


  getRolePermits(tipo: string, grupo: string): Observable<RestResponse> {
    let url = `${API.UserManagement.getRolePermits}`;
    url = url.replace('{tipo}', tipo);
    url = url.replace('{grupo}', grupo);
    return this.apiService.get(url);
  }

  addRolePermit(permit: any): Observable<RestResponse> {
    let url = `${API.UserManagement.addRolePermit}`;
    return this.apiService.post(url, permit);
  }

  deleteRolePermit(rolId: number, permisoId: number): Observable<RestResponse> {
    let url = `${API.UserManagement.deleteRolePermit}`;
    url = url.replace('{rolId}', rolId.toString());
    url = url.replace('{permisoId}', permisoId.toString());
    return this.apiService.delete(url);
  }
}
